import { isAfter, isBefore } from "date-fns"
import { IsValidCheck } from "./types"

export const isOnCoverWithinPolicyDatesError = `On cover date must be within policy dates`

export const isOnCoverWithinPolicyDates: IsValidCheck = (entry, _, policyDuration) => {
  if (!policyDuration?.startTime || !policyDuration?.endTime || !entry.onCoverDate) return undefined

  const policyStart = new Date(policyDuration.startTime)
  const policyEnd = new Date(policyDuration.endTime)
  const onCoverDate = new Date(entry.onCoverDate as string)
  return !isBefore(onCoverDate, policyStart) && !isAfter(onCoverDate, policyEnd)
}
